<template>
  <button
    :disabled="disabled"
    @click="emitClick"
    :style="customStyles"
    class="gradient-button"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  name: "GradientButton",
  props: ["title", "customStyles", "disabled"],
  emits: ["handleClick"],
  methods: {
    emitClick() {
      this.$emit("handleClick");
    },
  },
};
</script>

<style  scoped>
.gradient-button {
  display: flex;
  padding: 2px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 24px;
  background: linear-gradient(90deg, #fb8928 0%, #e50582 100%);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #fff;
  outline: none;
  border: none;
  width: fit-content;
}
.gradient-button:disabled {
  background: #b0b0b0;
  cursor: not-allowed;
  opacity: 0.7;
}
</style>